/* see docs/EXTRACTED_COMMENTS.md#c162 */
export function buildAssetUrl(path: string | undefined | null, base: string): string {
  if (path == null) return "";
  let normalized = path ?? "";
  try {
    normalized = decodeURIComponent(normalized);
  } catch (_e) {
    // ignore decode errors; keep original
  }

  try {
    return new URL(normalized, base).toString();
  } catch (_e) {
    const needsSlash = !base.endsWith("/") && !normalized.startsWith("/");
    return `${base}${needsSlash ? "/" : ""}${normalized}`;
  }
}

export async function isAssetCached(url: string | undefined | null): Promise<boolean> {
  if (!url) return false;
  if (typeof window === "undefined" || !("caches" in window)) return false;
  try {
    const match = await caches.match(url);
    return Boolean(match);
  } catch (_e) {
    return false;
  }
}


